import {Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import {MatDialog} from '@angular/material';
import {Business} from '../models/business.model';
import {AdminBusinessComponent} from '../admin-business/admin-business.component';
import {AirportService} from '../../airport/airport.service';

@Component({
  selector: 'app-flight-deck-button',
  templateUrl: './flight-deck-button.component.html',
  styleUrls: ['./flight-deck-button.component.scss']
})
export class FlightDeckButtonComponent implements OnInit {

  @Input() business: Business;
  @Output() businessChange = new EventEmitter<Business>();

  constructor(private _editContactDialog: MatDialog,
              private _airportService: AirportService) { }

  ngOnInit() {
  }

  flightDeckBusinessTools() {
    const dialogRef = this._editContactDialog.open(AdminBusinessComponent, {
      disableClose: false,
      autoFocus: true,
      width: '50%',
      data: {
        business: this.business
      }
    });
    dialogRef.afterClosed().subscribe(async () => {
      // On close, update the business to incorporate the new changes
      this.business = await this._airportService.getBusiness(this.business.id.toString());
      this.businessChange.emit(this.business);
    });
  }
}
